<template>
  <table class="checkout-summary" v-show="this.products.length > 0">
    <tbody>
    <tr class="margin-top">
      <td class="name">Sub Total</td>
      <td class="price" style="color: #323232;">
        <div v-if="subscription.coupon.apply_on=='invoice_amount'">
        <span v-if="subscription.originalSubTotal != subscription.subTotal" class="discounted-price">
          {{currencySymbol}}{{ (subscription.originalSubTotal / 100).toFixed(2) }}<br />
        </span>
        <span class="currency" v-if="this.products.length > 0"></span>
        {{currencySymbol}}{{ Number(this.subscription.subTotal / 100).toFixed(2) }}
        </div>
        <div v-if="subscription.coupon.apply_on!='invoice_amount'">
        <span class="currency" v-if="this.products.length > 0"></span>
        {{currencySymbol}}{{ Number(this.subscription.originalSubTotalWithDiscount / 100).toFixed(2) }}
        </div>
      </td>
    </tr>
    <tr class="margin-bottom"  v-if="this.shipment!=null">
      <td class="name">Shipping Cost</td>
      <td class="price">
        <span class="currency"></span>
        <span>{{ this.shipment.price > 0 ? currencySymbol + (this.shipment.price / 100).toFixed(2) : 'FREE'}}</span>
      </td>
    </tr>
    <tr class="margin-top total">
      <td class="name">Total</td>
      <td class="price">
        <span class="currency" v-if="this.products.length > 0"></span>
        {{currencySymbol}}{{ (this.subscription.grandTotal / 100).toFixed(2)}}
      </td>
    </tr>
    </tbody>
  </table>

</template>
<script>
export default {
  name: 'CheckoutSummary',
  props: ['subscription', 'products', 'shipment', 'currencySymbol']
}
</script>
